// Turbo Drive swaps the body without a document load, so the tag's own page_view fires only once
const trackPageView = () => {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_title: document.title,
  })
}

// turbo:load skips cache previews, so each rendered page counts exactly once
document.addEventListener('turbo:load', trackPageView)
